import React, { Component } from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

class GuideCaution extends Component{

  render(){
    return(
      <div className="caution">
        <p>
          <FormattedMessage
            id={'Guide.caution'}
            defaultMessage={'Caution'}
          />
         <span role="img" aria-label="">🔥</span>
        </p><br/>
        <FormattedHTMLMessage
          id={'Guide.caution.description'}
          defaultMessage={'Please submit characters using personal creation or gained licenses.<br/>(You may upload content that is repurposed from copyright that you own.)'}
        />
      </div>
    )
  }

}
export default GuideCaution;
